export class TogglePremiumDialogController {
    public static $inject: string[] = [
        "$mdDialog",
        "$mdMedia",
        "nbElemSelected"
    ];

    constructor(
        private $mdDialog: ng.material.IDialogService,
        public $mdMedia: ng.material.IMedia,
        public nbElemSelected: number,
        public saleDate: string,
        public isSaleInTwoDays: boolean,
        private askPremium?: string
    ) {
        askPremium = undefined;
    }

    public apply() {
        this.$mdDialog.hide(JSON.parse(this.askPremium));
    }

    public close() {
        this.$mdDialog.hide();
    }
}
